import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetWoodCertificationDetailTypesInputDto, WoodCertificationDetailTypeCreateDto, WoodCertificationDetailTypeDto, WoodCertificationDetailTypeExcelDownloadDto, WoodCertificationDetailTypeUpdateDto } from '../dtos/wood-certification-detail-type/models';

@Injectable({
  providedIn: 'root',
})
export class WoodCertificationDetailTypeService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: WoodCertificationDetailTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailTypeDto>({
      method: 'POST',
      url: '/api/geographic/woodCertificationDetailTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/woodCertificationDetailTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/woodCertificationDetailTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailTypeDto>({
      method: 'GET',
      url: `/api/geographic/woodCertificationDetailTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetailTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWoodCertificationDetailTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WoodCertificationDetailTypeDto>>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetailTypes',
      params: { name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: WoodCertificationDetailTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/woodCertificationDetailTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailTypeDto[]>({
      method: 'GET',
      url: '/api/geographic/woodCertificationDetailTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: WoodCertificationDetailTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDetailTypeDto>({
      method: 'PUT',
      url: `/api/geographic/woodCertificationDetailTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}